import { render, staticRenderFns } from "./Resultado.vue?vue&type=template&id=b3f0ca1a&scoped=true"
import script from "./Resultado.vue?vue&type=script&lang=js"
export * from "./Resultado.vue?vue&type=script&lang=js"
import style0 from "./Resultado.vue?vue&type=style&index=0&id=b3f0ca1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f0ca1a",
  null
  
)

export default component.exports